<template>
  <div class="footer">
    <div class="footer-wrapper clearfix">
      <div class="fl">
        <p class="footer-links" v-if="lang==='zh-cn'">
          <a target="_blank" href="https://www.yudou.cn" class="right" style="padding-left: 0;">友情链接：雨豆</a>|<a href="/join_us" class="right">加入我们</a>|<a href="/download" class="right">下载中心</a>|<a href="/help" class="right">帮助中心</a>
        </p>
        <p class="footer-links" v-else>
          <span class="lang-sel-wrapper">
            <span>English</span>
            <span class="zh-options" @click="changeLang">
              <div>中文</div>
            </span>
          </span>
          |
          <a href="/en/download" class="right">
          <!-- 下载中心 -->
            {{$t('home.xiazhongxin')}}
          </a>
        </p>
        <div class="footer-cr">
          <p>©{{year}} 清华大学&学堂在线</p>
          <p>
            <a target="_blank" href="https://beian.miit.gov.cn" style="display:inline-block;vertical-align: middle;color: #666;text-decoration: none;vertical-align: middle;">京ICP备14019655号</a> | <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802033052" style="display:inline-block;vertical-align: middle;color: #666;text-decoration: none;vertical-align: middle;"><img src="https://qn-sfe.yuketang.cn/o_1ek0bqrhrrj69vi1q681h091k069.png" style="vertical-align: middle;"/>&nbsp;<span>京公网安备 11010802033052号</span></a>
            <span>| 北京慕华信息科技有限公司</span>
          </p>
        </div>
      </div>
      <div class="footer-right fr">
        <img class="link-time" src="https://qn-sfe.yuketang.cn/o_1dlm30drldrp1jec1sf01ed51fna9.png" alt="雨课堂客服" v-if="lang==='zh-cn'">
        <img src="https://qn-sfe.yuketang.cn/o_1ehk70an21gnj1ot41u4p1e008099.png" class="link-time link-time-en" alt="雨课堂客服" v-else>
        <p class="link-tel" :class="{'text-right': lang==='en'}">400-689-1199</p>
        <div class="link-us clearfix">
          <div class="link-us-email fr">
            <div class="linkus-email-number">
              <p><a href="mailto:yuketang@xuetangx.com">yuketang@xuetangx.com</a></p>
              <p class="remark">邮箱</p>
            </div>
            <img class="link-img" src="https://qn-sfe.yuketang.cn/o_1bfogbbac1laj2ojlb8ur7c2o.png" alt="邮件" />
          </div>
          <div class="link-us-qq fr">
            <div class="link-us-qqgroup">
              <p>QQ:529448617（用户八群）</p>
              <p class="remark">雨课堂官方QQ群</p>
            </div>
            <img class="link-img" src="https://qn-sfe.yuketang.cn/o_1bfogaie01q2c1q53l811k74r62j.png" alt="qq" />
          </div>
          <div class="link-us-wechat fr">
            <div class="link-us-qcode"><img src="https://qn-sfe.yuketang.cn/o_1bfog83r555e54q11fh7a51c399.png" alt="雨课堂微信客服"></div>
            <img class="link-img" src="https://qn-sfe.yuketang.cn/o_1bfog9qnn1v2m8t6tb11oqn190ue.png" alt="微信" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
export default {
  data() {
    return {
      host: 'https://www.yuketang.cn',
      lang: Cookies.get('django_language') || 'zh-cn',
      year: new Date().getFullYear()
    }
  },
  methods: {
    changeLang() {
      location.href = `//${location.host}`
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer { z-index: 1; position: relative; width: 100%; background: #282C2F;}
  .footer-wrapper {
    box-sizing: border-box;
    margin: 0 auto;
    width: 1170px;
    height: 180px;
    color: #9B9B9B;
    font: 14px/1.5 'PingFang SC',arial,Helvetica Neue,tahoma,"Hiragino Sans GB",Microsoft YaHei,\5b8b\4f53;
  }
  .footer-cr {
    line-height: 25px;
    font-size: 12px;
    color: #666666;
  }

  .footer-cr a {
    color: #666;
  }
  .footer-cr img {
    vertical-align: middle;
  }

  .footer-links {
    padding-top: 48px;
    padding-bottom: 30px;
    cursor: pointer;
    .lang-sel-wrapper {
      position: relative;
      display: inline-block;
      padding-right: 26px;
      &::after {
        content: "";
        position: absolute;
        top: 2px;
        right: 10px;
        width: 6px;
        height: 6px;
        border: 2px solid #9b9b9b;
        transform: rotate(45deg);
        border-left-color: transparent;
        border-top-color: transparent;
      }
      .zh-options {
        position: absolute;
        left: 0;
        top: 20px;
        width: 100%;
        padding-top: 4px;
        text-align: center;
        cursor: pointer;
        z-index: 1;
        color: #666;
        visibility: hidden;
        div {
          line-height: 24px;
          background: #fff;
          border-radius: 4px;
        }
      }
      &:hover {
        .zh-options {
          visibility: visible;
        }
      }
    }
  }

  .footer-links a {
    padding: 0 10px;
    color: #9B9B9B;
    font-size: 14px;
  }

  .footer-right {
    padding-top: 48px;
    font-size: 20px;
    position: relative;
    right: 50px;
    .link-time-en {
      height: 18px;
      width: auto;
    }
  }

  .link-tel {
    padding-top: 8px;
    color: #9B9B9B;
  }
  .text-right {
    text-align: right;
  }
  .link-time {
    display: block;
    width: 137px;
  }

  .link-us {
    padding-top: 10px;
  }

  .link-us .link-us-wechat,
  .link-us .link-us-qq,
  .link-us .link-us-email {
    position: relative;
    margin-left: 15px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
  }

  .link-img {
    width: 26px;
    height: 26px;
  }

  .link-us-qcode,
  .link-us-qqgroup,
  .linkus-email-number {
    position: absolute;
    top: -215px;
    left: 50%;
    margin-left: -100px;
    padding: 20px;
    text-align: center;
    font-size: 16px;
    color: #333;
    background: #fff;
    border: 1px solid #282C2F;

    visibility: hidden;
    opacity: 0;
    cursor: default;
    transition: opacity 0.3s ease-in-out;
  }

  .link-us-qcode:after,
  .link-us-qqgroup:after,
  .linkus-email-number:after {
    position: absolute;
    left: 50%;
    margin-left: -15px;
    border-width: 12px 12px 0;
    border-style: solid;
    display: block;
    content: '.';
    font-size: 0;
    line-height: 0;
    width: 1px;
    height: 0;
    bottom: -11px;
    border-color: #fff transparent transparent transparent;
  }

  .link-us-qcode:before,
  .link-us-qqgroup:before,
  .linkus-email-number:before {
    position: absolute;
    left: 0;
    bottom: -20px;
    display: block;
    content: '.';
    width: 100%;
    height: 20px;
    background: transparent;
  }

  .link-us-qcode img{ display: block; margin: auto; width: 160px; height: 160px; }

  .link-us-qqgroup {
    top: initial;
    bottom: 48px;
    width: 230px;
    box-sizing: border-box;
    padding: 20px 10px;
    margin-left: -105px;
    line-height: 30px;
  }
  .link-us-qqgroup .remark,
  .linkus-email-number .remark {
    padding-top: 15px;
  }

  .linkus-email-number {
    top: -129px;
    width: 200px;
    box-sizing: border-box;
    padding: 20px 10px;
    margin-left: -98px;
    line-height: 30px;
  }

  .linkus-email-number a {
    color: #4a90e2;
    text-decoration: underline;
  }

  .link-us-wechat:hover .link-us-qcode,
  .link-us-qq:hover .link-us-qqgroup,
  .link-us-email:hover .linkus-email-number {
    opacity: 1;
    visibility: visible;
  }
</style>
